import { render } from "./JobInfo.vue?vue&type=template&id=68d003df&scoped=true"
import script from "./JobInfo.vue?vue&type=script&lang=js"
export * from "./JobInfo.vue?vue&type=script&lang=js"

import "./JobInfo.vue?vue&type=style&index=0&id=68d003df&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-68d003df"]])

export default __exports__